import api from '../api';

/**
 * Update a store with the given storeCode and updatedStore data.
 *
 * @param {string} storeCode - The code identifying the store to be updated.
 * @param {Object} updatedStore - The new details for the store.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const updateStore = async (storeCode, updatedStore) => {

  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/store/update`;

  try {
    const response = await api.post(endpoint, {
      store_code: storeCode,
      store: updatedStore,
    });
    return response.data;
  } catch (error) {
    console.error('Error updating store:', error);
    throw error;
  }
}

export default updateStore;
